import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { ITypeaheadList, minQueryLength, EUserType, EItemButtons, optionUserConfig } from '../../../domain/typeahead.interfaces';
import { makeSelectCurrentUser } from '../../../store/current-user/current-user.selectors';
import { resetUsers, getUsers } from '../../../store/users/users.actions';
import { makeSelectUsers } from '../../../store/users/users.selectors';
import { typeaheadItemFormatter } from '../../../utils/formatter';
import { TypeaheadComponent } from '../../atoms/atoms.index';

export function TypeaheadUserComponent(props: any) {

  const { onBlur, onQuery, onCancelQuery, onExpandTypeaheadOptions } = props;

  const dispatch = useDispatch();
  const [ref, setRef] = useState<any>(undefined);
  const [options, setOptions] = useState<ITypeaheadList[] | undefined>();
  const [query, setQuery] = useState<string | undefined>('');

  const users = useSelector(makeSelectUsers());
  const currentUser = useSelector(makeSelectCurrentUser());

  const handleInputChange = (pattern: string) => {
    setQuery(pattern.trim().toLowerCase());
  };

  const handleOnBlur = () => {
    dispatch(resetUsers());
    ref.getInstance().clear();
    if (onBlur) {
      onBlur();
    }
  };

  useEffect(() => {
    if (!query || query.trim().length < minQueryLength) {
      dispatch(resetUsers());
      if (onCancelQuery) {
        onCancelQuery();
      }

      return;
    }

    debouncedFetchUsers();
    if (onQuery) {
      onQuery(query);
    }

    // eslint-disable-next-line
  }, [query]);

  useEffect(() => {
    const apiUsers = users
      .filter((el: any) => !el.isContact && el.id !== currentUser.id)
      .map((user: any) => {
        const userType = user.active ? EUserType.USER : EUserType.INACTIVE;
        const unallowedButtons = user.isActive ? [] : [EItemButtons.WISHLIST];
        return typeaheadItemFormatter(
          optionUserConfig,
          user,
          userType,
          unallowedButtons,
        );
      });

    const userOption = {
      title: 'users',
      data: apiUsers,
    };

    const typeaheadOptions: ITypeaheadList[] = onExpandTypeaheadOptions ?
      onExpandTypeaheadOptions(userOption) :
      [userOption];

    setOptions(typeaheadOptions);
    // eslint-disable-next-line
  }, [users]);

  const fetchUsers = () => {
    dispatch(getUsers(query as string));
    return true;
  };

  const debouncedFetchUsers = _.debounce(fetchUsers, 300, { maxWait: 1000 });

  return (
    <FormattedMessage id='pages.my-contactlist.typeahead.placeholder'>
      {(txt: any) => (
        <TypeaheadComponent
          addRef={(r: any) => setRef(r)}
          label={txt}
          handleInputChange={handleInputChange}
          handleOnBlur={handleOnBlur}
          options={options}
        />
      )}
    </FormattedMessage>
  );
}
